import { render } from "./index.vue?vue&type=template&id=95b43e04"
const script = {}

import "./index.vue?vue&type=style&index=0&id=95b43e04&lang=css"

import exportComponent from "E:\\wwwroot\\FHTMS-work\\fh-vue-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__